var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 40V37.5H7.525L7.5 47.5C7.5 50.275 9.725 52.5 12.5 52.5H47.5C50.275 52.5 52.5 50.275 52.5 47.5V37.5H35V40H25ZM50 17.5H39.975V12.5L34.975 7.5H24.975L19.975 12.5V17.5H10C7.25 17.5 5 19.75 5 22.5V30C5 32.775 7.225 35 10 35H25V30H35V35H50C52.75 35 55 32.75 55 30V22.5C55 19.75 52.75 17.5 50 17.5ZM35 17.5H25V12.5H35V17.5Z",
    fill: "#4F6EF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/business_icon.31301d49753ab0b1a3c1cc39f1530601.svg";
export { ForwardRef as ReactComponent };